import * as Types from '../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type DomainLocationStatusQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type DomainLocationStatusQuery = { __typename?: 'Query', domainStatus?: { __typename?: 'DomainStatus', locations: Array<{ __typename?: 'LocationStatus', name: string, description: string, statuses: Array<{ __typename?: 'UserStatus', shortNumber?: string | null, e164?: string | null, deviceType?: Types.DeviceType | null, deviceDescription?: string | null, ipAddress?: string | null, registrationTime?: any | null, clientInfo?: string | null, registrationExpireTime?: any | null, linkedE164?: string | null, linkedShortNumber?: string | null, userId: number, linkedUserId?: number | null }> }> } | null };

export type DomainGatewayStatusQueryVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
}>;


export type DomainGatewayStatusQuery = { __typename?: 'Query', domainStatus?: { __typename?: 'DomainStatus', gateways: Array<{ __typename?: 'GatewayStatus', shortNumber?: string | null, e164?: string | null, gatewayId: number, ipAddress?: string | null, registrationTime?: any | null, clientInfo?: string | null, registrationExpireTime?: any | null, displayName: string }> } | null };


export const DomainLocationStatusDocument = gql`
    query DomainLocationStatus($domainId: Int!) {
  domainStatus(domainId: $domainId) {
    locations {
      name
      description
      statuses {
        shortNumber
        e164
        deviceType
        deviceDescription
        ipAddress
        registrationTime
        clientInfo
        registrationExpireTime
        linkedE164
        linkedShortNumber
        userId
        linkedUserId
      }
    }
  }
}
    `;

/**
 * __useDomainLocationStatusQuery__
 *
 * To run a query within a React component, call `useDomainLocationStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useDomainLocationStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainLocationStatusQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useDomainLocationStatusQuery(baseOptions: Apollo.QueryHookOptions<DomainLocationStatusQuery, DomainLocationStatusQueryVariables> & ({ variables: DomainLocationStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DomainLocationStatusQuery, DomainLocationStatusQueryVariables>(DomainLocationStatusDocument, options);
      }
export function useDomainLocationStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DomainLocationStatusQuery, DomainLocationStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DomainLocationStatusQuery, DomainLocationStatusQueryVariables>(DomainLocationStatusDocument, options);
        }
export function useDomainLocationStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DomainLocationStatusQuery, DomainLocationStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DomainLocationStatusQuery, DomainLocationStatusQueryVariables>(DomainLocationStatusDocument, options);
        }
export type DomainLocationStatusQueryHookResult = ReturnType<typeof useDomainLocationStatusQuery>;
export type DomainLocationStatusLazyQueryHookResult = ReturnType<typeof useDomainLocationStatusLazyQuery>;
export type DomainLocationStatusSuspenseQueryHookResult = ReturnType<typeof useDomainLocationStatusSuspenseQuery>;
export type DomainLocationStatusQueryResult = Apollo.QueryResult<DomainLocationStatusQuery, DomainLocationStatusQueryVariables>;
export const DomainGatewayStatusDocument = gql`
    query DomainGatewayStatus($domainId: Int!) {
  domainStatus(domainId: $domainId) {
    gateways {
      shortNumber
      e164
      gatewayId
      ipAddress
      registrationTime
      clientInfo
      registrationExpireTime
      displayName
    }
  }
}
    `;

/**
 * __useDomainGatewayStatusQuery__
 *
 * To run a query within a React component, call `useDomainGatewayStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useDomainGatewayStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDomainGatewayStatusQuery({
 *   variables: {
 *      domainId: // value for 'domainId'
 *   },
 * });
 */
export function useDomainGatewayStatusQuery(baseOptions: Apollo.QueryHookOptions<DomainGatewayStatusQuery, DomainGatewayStatusQueryVariables> & ({ variables: DomainGatewayStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DomainGatewayStatusQuery, DomainGatewayStatusQueryVariables>(DomainGatewayStatusDocument, options);
      }
export function useDomainGatewayStatusLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DomainGatewayStatusQuery, DomainGatewayStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DomainGatewayStatusQuery, DomainGatewayStatusQueryVariables>(DomainGatewayStatusDocument, options);
        }
export function useDomainGatewayStatusSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<DomainGatewayStatusQuery, DomainGatewayStatusQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<DomainGatewayStatusQuery, DomainGatewayStatusQueryVariables>(DomainGatewayStatusDocument, options);
        }
export type DomainGatewayStatusQueryHookResult = ReturnType<typeof useDomainGatewayStatusQuery>;
export type DomainGatewayStatusLazyQueryHookResult = ReturnType<typeof useDomainGatewayStatusLazyQuery>;
export type DomainGatewayStatusSuspenseQueryHookResult = ReturnType<typeof useDomainGatewayStatusSuspenseQuery>;
export type DomainGatewayStatusQueryResult = Apollo.QueryResult<DomainGatewayStatusQuery, DomainGatewayStatusQueryVariables>;